export default __webpack_public_path__ + "img/ng100.21e6d50b.jpg";